import React, { ReactNode, useEffect, useState } from 'react';

import { CompanyAuthContext } from './CompanyAuthContext';
import { fetchCompanyUserProfile } from './ProfileFetcher';
import { CompanyUserProfile } from './types/CompanyUserProfile';

export const CompanyAuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [profile, setProfile] = useState<CompanyUserProfile | undefined>();

  useEffect(() => {
    fetchCompanyUserProfile(setProfile);
  }, []);

  return (
    <CompanyAuthContext.Provider value={{ profile, setProfile }}>
      {children}
    </CompanyAuthContext.Provider>
  );
};
